<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Time Servers</h4>
      </div>
    </div>
    <div class="row" v-if="[3, 4].includes(logged_in_user.group_id)">
      <div class="col-8">
        <div class="alert alert-warning" role="alert">
          <b>Notice:</b> Updating Time Servers requires that the machine be restarted to take effect.
        </div>
      </div>
    </div>
    <div class="row" v-if="[3, 4].includes(logged_in_user.group_id)">
      <div class="col-12">
        <router-link :to="{ name:'AdminMachineTimeServerAdd' }" class="btn btn-success"><i class="fa fa-edit"
                                                                                      aria-hidden="true"></i>
          Add Server
        </router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Server</th>
            <th v-if="[3, 4].includes(logged_in_user.group_id)">Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="time_server in time_servers" :key="time_server.time_server_id">
            <td>{{ time_server.address }}</td>
            <td v-if="[3, 4].includes(logged_in_user.group_id)">
              <button type="button" class="btn btn-danger" @click="deleteTimeServer(time_server)"><i
                class="fa fa-trash fa-fw" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'time-server',
  computed: mapGetters({
    time_servers: 'allTimeServers',
    logged_in_user: 'loggedInUser'
  }),
  methods: mapActions([
    'deleteTimeServer'
  ]),
  created () {
    this.$store.dispatch('getTimeServers')
  }
}
</script>

<style scoped>

</style>
